import styled from "styled-components";
import { navigationHistory } from "../routes";

const PlayButtonScreen = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 600px;
  height: 500px;
`;

const MainPlayButton = styled.img`
  transform: scale(0.6);
  transition: 1s;
  :hover {
    transform: scale(0.8);
  }
`;

export default () => {
  return (
    <PlayButtonScreen onClick={() => navigationHistory.push("/games")}>
      <h2>Spiel jetzt starten</h2>
      <MainPlayButton src="/mainPlayButton.png" />
    </PlayButtonScreen>
  );
};
